import { LayoutAdminDefaultContainer, LayoutAdminDefaultPageTitle } from "@webtypen/react-components";
import { LayoutUsermenu } from "./LayoutUsermenu";
import { Logo } from "./Logo";

export const Page = ({ children, containerAttributes, ...rest }) => {
    return (
        <LayoutAdminDefaultContainer {...containerAttributes}>
            <LayoutAdminDefaultPageTitle logo={<Logo />} menuAppBar={<LayoutUsermenu />} {...rest} />

            {children}
        </LayoutAdminDefaultContainer>
    );
};
